// extracted by mini-css-extract-plugin
export default {"root":"OrderHistory_root__nw86v","toolBar":"OrderHistory_toolBar__CLFTa"};